module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "messages"
    }
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm._f("name")(_vm.partner)))])]), _vm._v(" "), _c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', {
      class: {
        mine: message.sender_id == _vm.user.id
      }
    }, [_c('p', [_vm._v(_vm._s(message.message))])])
  })), _vm._v(" "), _c('form', {
    attrs: {
      "id": "send-message"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "message",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Senden"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6310417e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/conversation.vue
// module id = 232
// module chunks = 0